export default "__VITE_ASSET__bUs$0Uhp__"